import React from "react";

export class PokerLiveInfo extends React.Component {


    constructor(props) {
        super(props);
        this.state = { pobjednici: null };


        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);



        


        this.fetchData();
    }



    fetchData() {
        var promises = Promise.all([casino.repos.pokerLiveInfoRepo.get()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        this.dataPromises.cancel();
        clearTimeout(this.dataInterval);
    }

    setData(data) {
        var [liveInfo] = data;
        this.setState({
            liveInfo: liveInfo
        });
        this.dataInterval = setTimeout(() => this.fetchData(), 10000);
    }
    render() {
        return <div>
            <div className="poker-container-wider padding-sides-medium-2 flex-equal-size ">
                <div className="text-center">
                    <div className="poker-stats stats-1 as-inline-block" /><br />
                    <div>
                        <span className="text-info info-3">{this.state && this.state.liveInfo ? this.state.liveInfo.igraca : '-'}</span><br />
                        <span className="text-info info-4">IGRAČA</span>
                    </div>
                </div>
                <div className="text-center">
                    <div className="poker-stats stats-2 as-inline-block" /><br />
                    <div className="border-sides-gray">
                        <span className="text-info info-3">{this.state && this.state.liveInfo ? this.state.liveInfo.cashStolova : '-'}</span><br />
                        <span className="text-info info-4">CASH STOLOVA</span>
                    </div>
                </div>
                <div className="text-center">
                    <div className="poker-stats stats-3 as-inline-block" /><br />
                    <div>
                        <span className="text-info info-3">{this.state && this.state.liveInfo ? this.state.liveInfo.turnirStolova : '-'}</span><br />
                        <span className="text-info info-4">TURNIRA</span>
                    </div>
                </div>
            </div>
        </div>
    }
};
